/* unplugin-vue-components disabled */import script from "./pc.vue?vue&type=script&setup=true&lang=js"
export * from "./pc.vue?vue&type=script&setup=true&lang=js"

import "./pc.vue?vue&type=style&index=0&id=c06c6802&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_do6gl7biqum247ry4qofa4hfiq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c06c6802"]])

export default __exports__